import { datatableCheck, datatableCheckHover, datatableClose, datatableCloseHover, datatableDelete, datatableDeleteHover, datatablePending } from 'assets/icons'
import ActiveDeactiveDialogConfirmation from 'components/ActiveDeactiveDialogConfirmation'
import UploadApproval from 'components/UploadApproval'
import moment from 'moment'
import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Tag } from 'primereact/tag'
import { classNames } from 'primereact/utils'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast, ToastContent } from 'react-toastify'
import { handleLoader, handleNotFound } from 'redux/counterSlice'
import { approveRejectApi, deleteUserDocApi, getFileProcessing } from 'services/documentApprovalService'

const DocumentApproval = () => {

    const [userList, setUserList] = useState<any>()
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [id, setId] = useState<number>();
    const [filters, setFilters] = useState<any>(null);
    const [deleteUserDoc, setDeleteUserDoc] = useState<{ id: [], deleted_by: string }>({ "id": [], deleted_by: "" })

    const [showDeleteDialogBox, setShowDeleteDialogBox] = useState(false)
    const [deleteItems, setDeleteItems] = useState<{
        id: number;
        is_approve: string;
        updated_by: string;
    }>();
    const [selectedProducts, setSelectedProducts] = useState<any>(null);
    const [active, setActive] = useState<string>("pending")
    const [deletedoc, setDeleteDoc] = useState<boolean>(false)
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [first, setFirst] = useState(0); // State to control the first page
    const [sortField, setSortField] = useState(""); // State to control the first page
    const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSort = (event: any) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        setFirst(0);  //Move to page 1
        // dispatch(setFirstVoice(0)); // Move to page 1
    };

    const fetchUserData = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getFileProcessing()
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result?.error
            }
            dispatch(handleLoader(false));
            setUserList(result)
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const getSeverity = (status: any) => {
        switch (status) {
            case 'Approved':
                return 'success';

            case 'Rejected':
                return 'warning';

            case "Pending":
                return null
        }
    };

    const onClear = () => {
        setShowDeleteDialogBox(false);
        setSelectedProducts(null);
        setDeleteUserDoc({ "id": [], deleted_by: "" });
        setDeleteDoc(false)
    }

    const onGlobalFilterChange = (e: any) => {
        setFirst(0);
        const value = e?.target?.value;
        setGlobalFilterValue(value);
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);

    };

    const onDeleteClick = ({ id }: { id: number }) => {
        setShowDeleteDialogBox(true)
        setDeleteUserDoc((prevState: any) => ({ ...prevState, id: [id], deleted_by: localStorage.getItem("username") }))
    }

    const onStatusClick = (e: any, { email, is_approved, id }: { email: string, is_approved: string, id: number }) => {
        e.stopPropagation();
        setId(id)
        setActive(is_approved)
    }

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue('');
    };

    const setDeleteUserList = async (isActive: boolean) => {
        if (selectedProducts?.length > 0) {
            selectedProducts.forEach((element: any) => {
                setDeleteUserDoc((prevState: any) => ({ ...prevState, id: [...prevState.id, element.id], deleted_by: localStorage.getItem("username") }))
            });
            setShowDeleteDialogBox(true)
        } else {
            toast.error("Please select at least one document to delete", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const approveReject = async (e: any, text: string) => {
        if (text === "No" || text === "") {
            return
        }
        setDeleteItems((prevState: any) => ({
            ...prevState, id: id, is_approve:
                text === "Approve" ? "approve" :
                    text === "Reject" ? "reject" :
                        text === "Yes" && "reject"
            , updated_by: localStorage?.getItem("username")
        }))

    }

    useEffect(() => {
        statusAPI();
    }, [deleteItems]);

    const statusAPI = async () => {
        dispatch(handleLoader(true));
        try {
            if (deleteItems) {
                const { result, error } = await approveRejectApi(deleteItems)
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                await fetchUserData();
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                onClear()
            }
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }


    const deleteDoc = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await deleteUserDocApi(deleteUserDoc)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            fetchUserData()
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            onClear()
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const openPDF = (pdf64: any) => {
        // Create a Blob from the base64 data
        const blob = new Blob([new Uint8Array(atob(pdf64).split("").map(c => c.charCodeAt(0)))], { type: 'application/pdf' });

        // Create a URL for the Blob
        const blobUrl = URL.createObjectURL(blob);

        // Open the Blob URL in a new tab
        window.open(blobUrl, '_blank');
    }


    useEffect(() => {
        dispatch(handleNotFound(false))
        fetchUserData()
        initFilters()
    }, [])

    const [is_hover_Delete, setIs_hover_Delete] = useState<string>("");
    const [is_hover_Close, setIs_hover_Close] = useState<string>("");
    const [is_hover_Check, setIs_hover_Check] = useState<string>("");

    const handleAction = (rowData: any) => {
        switch (rowData.is_approved) {
            case "approve":
                return (
                    <span className="mr-3 c-pointer" data-bs-toggle={"modal"} data-bs-target="#upload-Approval" onClick={(e) => { onStatusClick(e, rowData) }} onMouseEnter={() => setIs_hover_Check(rowData.id)} onMouseLeave={() => setIs_hover_Check("")}>
                        <img src={is_hover_Check === rowData.id ? datatableCheckHover : datatableCheck} alt='check-icon' />
                    </span>
                );
            case "reject":
                return (
                    <span className="mr-3" style={{ cursor: "default" }} onMouseEnter={() => setIs_hover_Close(rowData.id)} onMouseLeave={() => setIs_hover_Close("")}>
                        <img src={is_hover_Close === rowData.id ? datatableCloseHover : datatableClose} alt='close-icon' />
                    </span>
                );
            case "pending":
                return (
                    <span className="mr-3 c-pointer" data-bs-toggle={"modal"} data-bs-target="#upload-Approval" onClick={(e) => { onStatusClick(e, rowData) }}>
                        <img src={datatablePending} alt='pending-icon' />
                    </span>
                );
        }
    }
    const statusClass = (status: string) => {
        switch (status) {
            case "approve":
                return "active";
            case "reject":
                return "reject";
            case "pending":
                return "pending";
        }
    }

    return (
        <>
            <div className="datatable-wrapper">
                <div className='p-4 content-wrapper'>
                    <div className="switch-section user-management-section">
                        <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
                            <h4 className="mb-0">Document Approval</h4>
                            <div className="d-flex align-items-center table-right-row">
                                <div className='d-flex align-items-center table-right-first'>
                                    <div className='d-flex align-items-center table-search mr-3 mt-1 mb-1'>
                                        <IconField iconPosition="right" className='user-input'>
                                            <InputIcon className="pi pi-search"> </InputIcon>
                                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search by document details" />
                                        </IconField>
                                    </div>
                                </div>
                                <div className='table-right-end mt-1 mb-1'>
                                    <Button className='outline-icon-btn grey-outline-btn delete-btn' outlined label='Delete' data-bs-toggle={(selectedProducts && selectedProducts !== null && selectedProducts.length !== 0) && "modal"} data-bs-target="#active-deactive" onClick={() => setDeleteUserList(true)}></Button>
                                    {/* <Button className='ml-2 btn btn-outline-warning' label='Inactive' data-bs-toggle={ selectedProducts !== null &&  "modal"} data-bs-target="#active-deactive" onClick={() => setDeleteUserList(false)}></Button> */}
                                </div>
                            </div>
                        </div>
                        <DataTable
                            selection={selectedProducts}
                            selectionPageOnly
                            onSelectionChange={(e: any) => { setSelectedProducts(e.value) }}
                            paginator
                            filters={filters}
                            globalFilterFields={["first_name", "last_name", "file_name"]}
                            first={first}
                            onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
                            rows={rowsPerPage}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            sortMode="single"
                            onSort={handleSort}
                            rowsPerPageOptions={[5, 10, 25]}
                            stripedRows
                            value={userList}
                            tableStyle={{}}
                            emptyMessage="No document records found"
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                            <Column header="User Name" body={(rowData) => `${rowData.first_name} ${rowData.last_name}`} sortable sortField='first_name' ></Column>
                            <Column
                                field="documentName"
                                header="Document Name"
                                body={(rowData) => (
                                    <a href="#" onClick={() => openPDF(rowData.file_data)}>
                                        {rowData.file_name}
                                    </a>
                                )}
                            />
                            <Column
                                header="Date/Time"
                                body={(rowData: any) => (moment(rowData.created_at).format('MMM DD, YYYY HH:mm:ss'))}
                                sortable
                                sortField='created_at'
                            >
                            </Column>
                            <Column field="status" header="Status" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} body={(rowData) => (<Tag className={`status-tag ${statusClass(rowData.is_approved)}`} value={rowData.is_approved === "approve" ? 'Approved' : (rowData.is_approved === "reject" ? 'Rejected' : 'Pending')} severity={getSeverity(rowData.is_approved === "approve" ? 'Approved' : (rowData.is_approved === "reject" ? 'Rejected' : 'Pending'))} />)} />
                            <Column
                                header="Action"
                                body={(rowData) =>
                                (<div className='d-flex'>
                                    {/* <i style={{ cursor: rowData.is_approved === "reject" ? 'default' : 'pointer' }} data-bs-toggle={rowData.is_approved !== "reject" && "modal"} data-bs-target="#upload-Approval" className={classNames('pi', { 'text-green-500 pi-check-circle': rowData.is_approved === "approve", 'text-red-500 pi-times-circle': rowData.is_approved === "reject", "fa-regular fa-hourglass-half justify-content-center text-primary": rowData.is_approved === "pending" })} onClick={(e) => { onStatusClick(e, rowData) }}></i> */}
                                    {handleAction(rowData)}
                                    <span onMouseEnter={() => setIs_hover_Delete(rowData.id)} onMouseLeave={() => setIs_hover_Delete("")} data-bs-toggle="modal" data-bs-target="#active-deactive" onClick={() => { onDeleteClick(rowData) }}>
                                        <img src={is_hover_Delete === rowData.id ? datatableDeleteHover : datatableDelete} alt='delete-icon' />
                                    </span>
                                </div>)}>
                            </Column>
                        </DataTable>
                    </div>
                </div>
            </div>
            <UploadApproval status={active} approveReject={approveReject} />
            <ActiveDeactiveDialogConfirmation deletedoc={showDeleteDialogBox} changeStatus={deleteDoc} onCancel={onClear} />
        </>
    )
}

export default DocumentApproval